import { EXLY_BACKEND_API_HOST } from "repoV2/constants/apis";

export const express_interest_api = {
    create: `${EXLY_BACKEND_API_HOST}/host/interest/create`,
};
